// extracted by extract-css-chunks-webpack-plugin
module.exports = {"checkbox":"css-a4_osDX98C","checkbox_input":"css-o66iFQ8-nM","checkbox_content":"css-1xtLhsCAw2","checkbox__error":"css-DqG6MK7GTY"};